// Constants
const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
const COOKIE_PREFIX = 'hisably_';
const DEFAULT_COOKIE_DAYS = 60;

// Set cookie with optional secure and domain settings
export function setCookie(name, value, days = DEFAULT_COOKIE_DAYS, options = {}) {
  const expires = new Date(Date.now() + days * 864e5).toUTCString(); // 864e5 = 24*60*60*1000
  
  const cookieOptions = [
    `${encodeURIComponent(name)}=${encodeURIComponent(value)}`,
    `Expires=${expires}`,
    'Path=/',
    'SameSite=Lax',
    options.secure ? 'Secure' : '',
    options.domain ? `Domain=${options.domain}` : ''
  ].filter(Boolean).join('; ');

  document.cookie = cookieOptions;
}

// Get cookie (optimized with reduce)
export function getCookie(name) {
  const value = document.cookie
    .split('; ')
    .find(cookie => cookie.startsWith(`${encodeURIComponent(name)}=`));
  
  return value ? decodeURIComponent(value.split('=')[1]) : null;
}

// Get all cookies as object (bonus utility)
export function getAllCookies() {
  return Object.fromEntries(
    document.cookie.split('; ').map(cookie => {
      const [key, value] = cookie.split('=');
      return [decodeURIComponent(key), decodeURIComponent(value)];
    })
  );
}

export function deleteCookie(name, options = {}) {
  const cookieOptions = [
    `${encodeURIComponent(name)}=`,
    'Expires=Thu, 01 Jan 1970 00:00:00 GMT',
    'Path=/',
    options.domain ? `Domain=${options.domain}` : '',
    'SameSite=Lax',
    options.secure ? 'Secure' : ''
  ].filter(Boolean).join('; ');

  document.cookie = cookieOptions;
}

export function clearUtmCookies() {
  UTM_KEYS.forEach(key => {
    deleteCookie(`${COOKIE_PREFIX}${key}`);
  });
}